import { render, staticRenderFns } from "./BannerDownloadMobileApps.vue?vue&type=template&id=66ab1832"
import script from "./BannerDownloadMobileApps.vue?vue&type=script&lang=js"
export * from "./BannerDownloadMobileApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports